module.exports = __webpack_public_path__ + "img/t-b-r.d480dcf5.png";